import formatMoney from '../../core/formatMoney';

export default () => {
  const shipping_bar = document.querySelectorAll('[data-shipping-bar]');

  if (shipping_bar.length === 0) {
    return false;
  }

  const free_shipping = Number(shipping_bar[0].dataset.freeShipping) / 100;
  const cart_subtotal = window.theme.cart.data.total_price / 100;
  let percent_progress = (cart_subtotal / free_shipping) * 100;
  let message = 'Your order qualifies for <strong>FREE SHIPPING</strong>.';

  if (percent_progress > 100) {
    percent_progress = 100;
  } else {
    message = `You're <strong>${formatMoney((free_shipping - cart_subtotal) * 100, theme.moneyFormat)}</strong> away from <strong>FREE SHIPPING</strong>`;
  }

  shipping_bar.forEach(sb => {
    sb.querySelector('.shipping-bar__message').innerHTML = message;
    sb.querySelector('.shipping-bar__progress').style.width = `${percent_progress}%`;
  });

  return true;
};
